export default __webpack_public_path__ + "images/BP.bf1cf71.png";